// import Branding from '@common/components/Branding';
import Branding from '@common/components/Branding';
import SEO from '@common/components/SEO';
// import SliderComponent from '@common/components/Slider';
import Toasts from '@common/components/Toasts';
import TrustBanner from '@common/components/TrustBanner';
// import { Banner, SectionEnum } from '@common/models/sections';
import {
  addProductToCart,
  CartSliceType,
  removeProductFromCart,
  setProductQuantityInCart,
  subtractProductFromCart,
} from '@common/store/cart/slice';
import {
  CategoriesSliceType,
  fetchCategoriesRequest,
  getCategoryQueryParamsInitialState,
} from '@common/store/categories/slice';
import { CustomPagesSliceType } from '@common/store/customPages/slice';
import { FeaturesSliceType } from '@common/store/features/slice';
import { FilterBarSliceType } from '@common/store/filterBar/slice';
import { HomeSliceType } from '@common/store/home/slice';
import { PoliciesSliceTosType } from '@common/store/policiesTos/slice';
import { fetchProductsRequest, ProductsSliceType } from '@common/store/products/slice';
import { fetchSearchRequest, SearchSliceType } from '@common/store/search/slice';
import { CustomMetaTagsSliceType } from '@common/store/seo/customMetaTags/slice';
import { SliderSliceType } from '@common/store/slider/slice';
import { StoreInfoSliceType } from '@common/store/storeInfo/slice';
import { addToast, removeToast, ToastWithKeyType } from '@common/store/toasts/slice';
import { UserProfileSliceType } from '@common/store/userProfile/slice';
import { UserSectionsSliceType } from '@common/store/userSections/slice';
import Footer from '@components/Footer';
// import Navbar from '../Navbar';
import Navbar from '@layouts/Navbar';
import React from 'react';
import { connect } from 'react-redux';

import { RootState } from '../../../../common/store';

export interface PageLayoutProps {
  children: React.ReactNode;
  topChildren?: React.ReactNode;
  cart: CartSliceType;
  customMetaTags: CustomMetaTagsSliceType;
  products: Record<number, ProductsSliceType>;
  toasts: ToastWithKeyType[];
  storeInfo: StoreInfoSliceType;
  home: HomeSliceType;
  slider: SliderSliceType;
  search: Record<string, SearchSliceType>;
  addProductToCart: typeof addProductToCart;
  removeProductFromCart: typeof removeProductFromCart;
  setProductQuantityInCart: typeof setProductQuantityInCart;
  subtractProductFromCart: typeof subtractProductFromCart;
  addToast: typeof addToast;
  removeToast: typeof removeToast;
  showBanner?: boolean;
  fetchSearchRequest: typeof fetchSearchRequest;
  customPages: CustomPagesSliceType;
  userProfile: UserProfileSliceType;
  userSections: UserSectionsSliceType;
  features: FeaturesSliceType;
  filterBar: FilterBarSliceType;
  policiesTos: PoliciesSliceTosType;
  categories: CategoriesSliceType;
  fetchProductsRequest: typeof fetchProductsRequest;
  fetchCategoriesRequest: typeof fetchCategoriesRequest;
}

const PageLayout: React.FunctionComponent<PageLayoutProps> = ({
  customPages,
  // cart,
  toasts,
  children,
  // addProductToCart,
  // removeProductFromCart,
  // subtractProductFromCart,
  addToast,
  removeToast,
  storeInfo,
  // slider,
  // home,
  // showBanner,
  // fetchSearchRequest,
  // search,
  // userProfile,
  userSections,
  features,
  filterBar,
  // setProductQuantityInCart,
  policiesTos,
  categories,
  // fetchProductsRequest,
  fetchCategoriesRequest,
}) => {
  // const banner = home?.sections?.find((section) => section.type === SectionEnum.BANNER) as Banner;
  if (!categories.isFetched && !categories.isFetching) {
    fetchCategoriesRequest({
      queryParams: getCategoryQueryParamsInitialState(),
      ordering: 'order',
    });
  }
  const pageHeaderLayout = userSections.userSections?.find((section) => section.sectionType === 'Page Header');
  return (
    <div className="bg-page pageLayout" color-customisation="page-bg">
      {pageHeaderLayout ? <Navbar id={pageHeaderLayout.id} /> : null}
      <SEO />
      {toasts.length > 0 ? (
        <div className="mt-80 md:mt-0">
          <Toasts toasts={toasts} addToast={addToast} removeToast={removeToast} />
        </div>
      ) : null}

      {/* {showBanner && slider.isFetched && home.isFetched && (banner?.bannerEnabled || banner?.sliderEnabled) ? (
        <div>
          <SliderComponent banner={banner} slider={slider} />
        </div>
      ) : null} */}
      <div className="flex-1">{children}</div>
      <TrustBanner storeInfo={storeInfo.storeInfo} />
      <Footer
        storeInfo={storeInfo.storeInfo}
        customPages={customPages}
        features={features}
        filterBar={filterBar}
        policies={policiesTos}
        pageHeaderID={pageHeaderLayout?.id}
      />
      <Branding className="mt-40" showTrustBadge={false} />
    </div>
  );
};

export default connect(
  ({
    cart,
    seo: { customMetaTags },
    products,
    features,
    slider,
    toasts,
    storeInfo,
    home,
    search,
    customPages,
    userProfile,
    userSections,
    filterBar,
    policiesTos,
    categories,
  }: RootState) => ({
    search,
    home,
    cart,
    customMetaTags,
    slider,
    features,
    products,
    toasts,
    storeInfo,
    customPages,
    userProfile,
    userSections,
    filterBar,
    policiesTos,
    categories,
  }),
  {
    addProductToCart,
    removeProductFromCart,
    subtractProductFromCart,
    addToast,
    removeToast,
    fetchSearchRequest,
    setProductQuantityInCart,
    fetchProductsRequest,
    fetchCategoriesRequest,
  },
)(PageLayout);
